import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { IDoctorsSuppliers } from 'Interfaces/doctorsSuppliers';
import * as yup from 'yup';

const dictionary = Dictionary[DICTIONARY.Suppliers].doctorsSearchForm;

export const DoctorsSchema = yup.object().shape({
  supName: yup.string().nullable().default(null),
  specialty: yup.number().nullable().required(dictionary.requiredError),
  area: yup.number().nullable().default(null),
  region: yup.number().nullable().default(null),
  city: yup.array().of(yup.number().nullable().default(null)),
  accessible: yup.boolean().nullable().default(null),
  lng: yup.array().of(yup.number().nullable().default(null)),
  gender: yup.number().nullable().default(null),
  homeVisit: yup.boolean().nullable().default(null),
}) as yup.SchemaOf<IDoctorsSuppliers>;
